module.exports = __webpack_public_path__ + "img/brain.1b6da957.svg";